import Instructors from '@assets/instructors.jpg';
import InstructorBrady from '@assets/instructor-brady.png';
import InstructorAlex from '@assets/instructor-alex.png';
import React from 'react';
import styled from 'styled-components';
import { H2, H6, PSmall } from '../../../components/Typography/Typography';
import { SVG, UniqueComponent } from '../../../icons/Icons';
import { media } from '../../../components/style-utils';

export const SectionInstructors = function() {
  return (
    <Container>
      <TextBox>
        <Image />
        <Headline>
          Meet your
          <br />
          instructors
        </Headline>
      </TextBox>

      <InstructorList>
        <InstructorItem>
          <InstructorImage src={InstructorBrady} />
          <InstructorText>
            <InstructorHeadline>
              <Colored>Brady Shearer</Colored> &mdash; Creator of Pro Church Tools and Nucleus &mdash; Lead Instructor
            </InstructorHeadline>
            <InstructorStatement>
              For close to a decade, Brady has been teaching church leaders how to use social media effectively. More
              than 75,000 pastors and leaders subscribe to his training and content focusing on helping churches
              navigate the biggest communication shift in 500 years.
            </InstructorStatement>
          </InstructorText>
        </InstructorItem>

        <InstructorItem>
          <InstructorImage src={InstructorAlex} />
          <InstructorText>
            <InstructorHeadline>
              <Colored>Alexander Mills</Colored> &mdash; Local Pastor &mdash; Instructor
            </InstructorHeadline>
            <InstructorStatement>
              Alex works as an Associate Pastor and content creator &mdash; using social for ministry and to help
              disciple his church. He uniquely understands the challenges of the local church as he works in the
              trenches integrating social into his pastoral care.
            </InstructorStatement>
          </InstructorText>
        </InstructorItem>
      </InstructorList>
    </Container>
  );
};

const Container = styled.section`
  overflow: hidden;
`;

const TextBox = styled.div`
  position: relative;

  color: var(--colorWhite);
`;

const Headline = styled(H2)`
  margin: 0;

  z-index: 2;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  ${media.tabletPortraitAndUp`
    font-size: 8.5rem;
  `}

  ${media.tabletLandscapeAndUp`
    left: 40rem;
  `}
`;

const InstructorList = styled.ul`
  padding: 5rem 1.2rem;
  width: 100vw;

  max-width: 90rem;
  margin-left: auto;
  margin-right: auto;
`;

const InstructorItem = styled.li`
  display: flex;
  align-items: flex-start;
`;

const InstructorImage = styled.img`
  max-width: 30%;

  ${media.tabletPortraitAndUp`
    max-width: 16rem;
  `}
`;

const InstructorText = styled.div`
  padding-left: 2rem;
`;

const InstructorHeadline = styled(H6)`
  margin-top: 2.5rem;
  font-weight: 700;
  line-height: 1.2em;
`;

const InstructorStatement = styled(PSmall)`
  max-width: 50rem;
`;

const Colored = styled.span`
  color: var(--colorPrimaryMedium);
`;

class ClippedImage extends UniqueComponent {
  static propTypes = {
    // src: PropTypes.string,
    // xAlignment: PropTypes.oneOf(['Min', 'Mid', 'Max']),
    // yAlignment: PropTypes.oneOf(['Min', 'Mid', 'Max']),
    // fillMode: PropTypes.oneOf(['meet', 'slice']),
    // viewBox: PropTypes.string,
    // clippingPath: PropTypes.string,
    // overlayColor: PropTypes.string,
  };
  static defaultProps = {
    xAlignment: 'Mid',
    yAlignment: 'Mid',
    fillMode: 'slice',
    overlayColor: 'transparent',
  };

  render() {
    let { src, xAlignment, yAlignment, fillMode, viewBox, clippingPath, overlayColor, ...otherProps } = this.props;

    return (
      <SVG {...otherProps} viewBox={viewBox} preserveAspectRatio={`x${xAlignment}Y${yAlignment} ${fillMode}`}>
        <defs>
          <pattern id={this.uniqueName('ImagePattern')} patternUnits="userSpaceOnUse" width="100%" height="100%">
            <image
              xlinkHref={src}
              x="0"
              y="0"
              width="100%"
              height="100%"
              preserveAspectRatio={`x${xAlignment}Y${yAlignment} ${fillMode}`}
            />
            <rect width="100%" height="100%" transform="translate(0,0)" fill={overlayColor} />
          </pattern>
        </defs>

        <path fill={this.uniqueUrl('ImagePattern')} d={clippingPath} />
      </SVG>
    );
  }
}

const ImageCutout = function(props) {
  return (
    <ClippedImage
      {...props}
      yAlignment="Min"
      src={Instructors}
      clippingPath="M0 0l3000 251.1v911.5H1637.7a45 45 0 00-25.7 8l-91 63.4a45 45 0 01-52.7-1l-81.6-61.3a45 45 0 00-27-9H0V0z"
      viewBox="0 0 3000 1243"
      overlayColor="rgba(0, 0, 0, 0.0)"
    />
  );
};

const Image = styled(ImageCutout)`
  width: 200%;
  transform: translateX(-25%);

  ${media.tabletLandscapeAndUp`
      width: 100%;
      transform: translateX(0);
  `}
`;



// WEBPACK FOOTER //
// ./src/routes/Home/components/SectionInstructors.js